import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, Overline } from "./Reveal";

export default function ProductCard({ product, index = 0 }) {
  return (
    <FadeUp delay={index * 0.06} className="h-full">
      <div className="group flex h-full flex-col" data-testid={`product-card-${product.slug}`}>
        <Link
          to={`/products/${product.category}/${product.id}`}
          className="relative block overflow-hidden rounded-lg bg-sage"
        >
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="aspect-[4/5] w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
          />
          {product.featured && (
            <span className="absolute left-3 top-3 rounded-full bg-bone/90 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-forest-700">
              Popular
            </span>
          )}
        </Link>
        <div className="flex flex-1 flex-col pt-4">
          <Overline className="text-[10px] text-terra">{product.brand}</Overline>
          <h3 className="font-display mt-1.5 text-xl font-bold text-forest-700">{product.name}</h3>
          {product.tagline && (
            <p className="mt-1.5 text-sm leading-relaxed text-moss line-clamp-2">{product.tagline}</p>
          )}
          <div className="mt-auto flex flex-wrap items-center gap-3 pt-4">
            <Link
              to={`/contact?interest=${encodeURIComponent(product.name)}`}
              data-testid={`product-request-quote-${product.slug}`}
              className="inline-flex items-center gap-1.5 rounded-full bg-forest-700 px-4 py-2 text-xs font-bold text-bone transition-colors hover:bg-terra"
            >
              Request Quote <ArrowRight className="h-3.5 w-3.5" />
            </Link>
            <Link
              to={`/products/${product.category}/${product.id}`}
              data-testid={`product-view-${product.slug}`}
              className="text-xs font-bold text-forest-700 underline underline-offset-4 transition-colors hover:text-terra"
            >
              View details
            </Link>
          </div>
        </div>
      </div>
    </FadeUp>
  );
}
